"use client"
import { cn } from "@abraxas/ui/lib"
import { Button } from "@abraxas/ui/ui"

export const TelegramFooter = ({ className }: { className?: string }) => (
  <div className={cn("relative bg-brand-blue-600", className)}>
    <div className="flex flex-col items-center gap-6 pt-16">
      <div className="flex items-center justify-center">
        <img
          src="https://lock.nyc3.cdn.digitaloceanspaces.com/assets/lockgram.webp"
          alt="lockgram"
          className="w-40 h-40"
        />
      </div>
      <p className=" text-m_uppercase md:text-uppercase uppercase tracking-[4%] text-center">
        loomlock updates
      </p>
      <div className="flex flex-col gap-2 items-center text-center">
        <h2 className="font-semibold text-m_heading-xs md:text-heading-xs text-neutral-white">
          <span className="text-accent-yellow">stay focused</span> with updates
        </h2>
        <p className="text-m_body-s md:text-body-m">
          Get productivity tips, success stories, and loomlock updates delivered
          to your inbox.
        </p>
      </div>
      <Button href="https://t.me/loomlockupdates">Get updates</Button>
    </div>
    <div
      className="md:h-auto h-48 bg-center bg-cover opacity-70"
      style={{
        backgroundImage: `url("https://lock.nyc3.cdn.digitaloceanspaces.com/assets/footer-lg.webp")`,
      }}
    >
      <img
        src="https://lock.nyc3.cdn.digitaloceanspaces.com/assets/footer-lg.webp"
        className="w-full h-auto md:mt-4 mt-16 hidden md:block"
        alt="decoration"
      />
    </div>
  </div>
)
